import { render, staticRenderFns } from "./TemplateMessageButtons.vue?vue&type=template&id=64890590&scoped=true"
import script from "./TemplateMessageButtons.vue?vue&type=script&lang=js"
export * from "./TemplateMessageButtons.vue?vue&type=script&lang=js"
import style0 from "./TemplateMessageButtons.vue?vue&type=style&index=0&id=64890590&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64890590",
  null
  
)

export default component.exports